import { Typography } from '@mui/material'

interface Props {
  name: string
}

export const IssueCardBlockInfo = ({ name }: Props) => (
  <Typography variant='body2'>{name}</Typography>
)
